const contentTypeJson = "application/json";
const apiProject = "/api/project";

// Get a Project.
const getProject = function (projectId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiProject + "/" + projectId, requestOptions)
    .then(handleResponse)
    .then((project) => {
      return project;
    });
};

// Get a Project URL to inguo front.
const getProjectUrl = function (projectId, moduleId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(
    apiProject + "/" + projectId + "/url/" + moduleId,
    requestOptions
  )
    .then(handleResponse)
    .then((res) => {
      return res;
    });
};

// Get the meter events for a given projectId
const meterEvents = function (projectId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiProject + "/" + projectId + "/meterEvents", requestOptions)
    .then(handleResponse)
    .then((events) => {
      return events;
    });
};

// Update a Project.
const updateProject = function (projectId, project) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify(project),
  };

  return fetch(apiProject + "/" + projectId, requestOptions)
    .then(handleResponse)
    .then((projectResp) => {
      return projectResp;
    });
};

// Get a Project URL to inguo front.
const getModuleEnabledList = function (projectId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiProject + "/" + projectId + "/enabledModule", requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
};

const whitelistAccess = function (projectId) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(
    apiProject + "/" + projectId + "/whitelistAccess",
    requestOptions
  )
    .then(handleResponse)
    .then((resp) => {
      return resp;
    });
};

const handleResponse = function (resp) {
  return resp.text().then((text) => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = e;
    }
    if (!resp.ok) {
      if (resp.status === 503) {
        localStorage.removeItem("user");
        location.replace("/maintenance");
      }

      if (resp.status === 403) {
        localStorage.removeItem("user");
        location.replace("/login");
      }

      if (resp.status === 401) {
        location.reload(true);
      }

      if (resp.status === 404) {
        location.replace("/error?err=404");
      }

      if (resp.status === 400 && data.message === "User does not have permission for group") {
        location.replace("/error?err=403");
      }

      const err = (data && data.message) || resp.statusText;
      return Promise.reject(err);
    }

    return data;
  });
};

export const projectService = {
  getProject,
  getProjectUrl,
  meterEvents,
  updateProject,
  getModuleEnabledList,
  whitelistAccess,
};
